<ng-container *portal>
  <div class="print-container">
    <div class="print">
      <span id="print.title" class="print__title">{{title}}</span>
      <span id="print.date" class="print__date">{{dateCreated}}</span>
      <div class="print-section" *ngFor="let printSection of printSections">
        <span class="print-section__title" *ngIf="printSection.sectionName">{{printSection.sectionName}}</span>
        <div class="print-section__item" *ngFor="let item of printSection.labeledValues">
          <span class="print-section__label">{{item.label}}</span>
          <span class="print-section__value">{{item.value}}</span>
        </div>
        <ng-container *ngIf="printSection.tableData.length > 0">
          <table class="print-table">
            <tbody>
              <tr>
                <th class="print-table__header" *ngFor='let columnHeader of objectKeys(printSection.tableData[0])'>
                  {{formatUtils.titleCase(columnHeader)}}
                </th>
              </tr>
              <ng-container *ngFor='let data of printSection.tableData'>
                <tr>
                  <td class="print-table__data" *ngFor='let key of objectKeys(printSection.tableData[0])'>
                    {{data[key]}}
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </ng-container>
      </div>
    </div>
    <div class="row row--end margin-top margin-top--lg hide-print">
      <button class="btn btn--primary" onclick="print()">Print</button>
    </div>
  </div>
</ng-container>
